import React from 'react'
import { FocusDebtAccount } from '../types'
import { FetchHookState } from './useGetDebtPlanFocusAccount'

export type DebtPlanFocusAccountValue = FetchHookState<FocusDebtAccount>

export const DebtPlanFocusAccountContext = React.createContext<
  DebtPlanFocusAccountValue | undefined
>(undefined)

export function useDebtPlanFocusAccount(): DebtPlanFocusAccountValue {
  const context = React.useContext(DebtPlanFocusAccountContext)
  if (context === undefined)
    // istanbul ignore next
    throw new Error(
      'useDebtPlanFocusAccount must be used within a DebtPlanFocusAccountProvider',
    )
  return context
}
